import React from "react";
import InvitationForm from "./InvitationForm";
import { FaUserPlus } from "react-icons/fa";
import { appName } from "../../../utils/constants";

export default function InvitationPage() {
  return (
    <div
      className="h-screen w-screen poppins-regular 
    bg-[url('https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=3908&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')]
    bg-cover bg-center bg-no-repeat
    "
    >
      <div className="bg-white bg-opacity-50 h-full w-full flex flex-col items-center justify-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md mx-auto border border-gray-100">
          <div className="flex flex-col items-center gap-6">
            <div className="flex flex-col items-center gap-4">
              <div className="title-header">{appName}</div>
              <div className="text-[#363062] text-lg font-semibold flex items-center gap-2">
                <FaUserPlus className="text-[#8FCD00]" />
                Family Invitation
              </div>
              <div className="text-gray-500 text-sm text-center">
                {`Congratulations! You've been invited by a family member to use
                ${appName}.`}
              </div>
              <div className="text-gray-600 text-sm text-center">
                Sign up below to get started
              </div>
            </div>

            <InvitationForm />
          </div>
        </div>
      </div>
    </div>
  );
}
